import TestimonialsSection from "./TestimonialsSection";

export { TestimonialsSection };
